import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../../../../components/Checkbox";
import Input from "../../../../components/Input";
import Loadign from "../../../../components/Loading";
import Wrapper from "../../../../components/Wrapper";
import Select from "../../../../components/Select";
import cloneDeep from "lodash/cloneDeep";
import "./index.css";
import { checkMinMax, priceNumbers } from "../../../../controllers";
import { showPrice } from "../../../../global/functions";

class NonFinancialClaims extends Component {
  constructor(props) {
    super(props);
    this.option = [
      "مطلق دعاوی خانوادگی یا دعاوی ناشی از زوجیت و همچنین امور حسبی",
      "دعاوی که خواسته آن ها مالی نیست یا تعیین بهای خواسته به موجب قانون لازم نیست",
    ];
    this.state = {
      price: {
        value: props.gheyrMali["hoghooghPaye"].toLocaleString(),
        max: "maxHagholvekale",
        min: "minHagholvekale",
      },

      tableInput: {
        omooriEjraiiValue: "",
      },

      tableItems: [
        {
          title: "بدوی",
          value: "badvi",
          showPrice: {
            value: "badviCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
        },
        {
          title: "تجدید نظر",
          value: "tajdidNazar",
          showPrice: {
            value: "tajdidNazarCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
        },
        {
          title: "دیوان عالی کشور",
          value: "divanAli",
          showPrice: {
            value: "divanAliCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: false,
        },
        {
          title: "امور اجرایی",
          value: "omooriEjraii",
          showPrice: {
            value: "omoorEjraiiCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "omooriEjraiiValue",
            min: "minEjra",
            max: "maxEjra",
          },
          disable: false,
        },
      ],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { gheyrMali, sendData, setMinMax } = this.props;
    if (gheyrMali.noeDaavi !== prevProps.gheyrMali.noeDaavi) {
      setMinMax(1);
    }
    if (JSON.stringify(gheyrMali) !== JSON.stringify(prevProps.gheyrMali)) {
      sendData("GheyrMali");
    }
  }

  render() {
    const { price, tableItems, tableInput } = cloneDeep(this.state);
    const { gheyrMali, setGheyrMali, minMax, header, footer, loadign } =
      cloneDeep(this.props);
    return (
      <Wrapper>
        <header className="flex flex-center py-4">
          <div className="flex ">
            <label className="text-normal m-0 ml-2">نوع دعوی:</label>
            <Select
              value={gheyrMali["noeDaavi"]}
              setValue={(e) => {
                gheyrMali["noeDaavi"] = Number(e.target.value);
                setGheyrMali(gheyrMali);
              }}
              items={this.option}
            />
          </div>
        </header>
        <main className="flex column flex-center mt-2">
          <div className="flex justify-between full-width">
            <div />
            <Input
              value={price.value}
              onChange={(e) => {
                var value = e.target.value;
                gheyrMali["hoghooghPaye"] = Number(
                  priceNumbers(value).replace(/[^0-9.]/g, "")
                );
                setGheyrMali(gheyrMali);
                price.value = priceNumbers(value);
                this.setState({ price });
              }}
              append="ریال"
              prepend={
                header["tarefeYaGharadad"]
                  ? "حق الوکاله پایه"
                  : "حق الوکاله مورد توافق"
              }
              inputClassName="text-center dir-ltr"
            />
            <div
              className={`
              text-${
                checkMinMax(
                  gheyrMali["hoghooghPaye"],
                  minMax[price.min],
                  minMax[price.max]
                )
                  ? "success"
                  : "danger"
              }
               flex flex-center`}
            >
              {loadign ? (
                <Loadign />
              ) : (
                <>
                  حداقل مبلغ {minMax[price.min].toLocaleString()} ریال و حداکثر
                  مبلغ {minMax[price.max].toLocaleString()} ریال وارد کنید
                </>
              )}
            </div>
          </div>
          <table className="mt-4">
            <tbody>
              {tableItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Checkbox
                      value={gheyrMali[item.value]}
                      setValue={() => {
                        gheyrMali[item.value] = !gheyrMali[item.value];
                        setGheyrMali(gheyrMali);
                      }}
                      disable={item.disable}
                      title={item.title}
                    />
                  </td>
                  {item.showPrice !== null ? (
                    <td>
                      {showPrice(
                        eval(item.showPrice.subsetOf),
                        item.showPrice.value
                      )}
                    </td>
                  ) : null}
                  {item.changePrice !== null ? (
                    <td>
                      <Input
                        value={tableInput[item.changePrice.value]}
                        onChange={(e) => {
                          gheyrMali[item.changePrice.value] = Number(
                            priceNumbers(e.target.value).replace(/[^0-9.]/g, "")
                          );
                          setGheyrMali(gheyrMali);
                          tableInput[item.changePrice.value] = priceNumbers(
                            e.target.value
                          );
                          this.setState({ tableInput });
                        }}
                        inputClassName="text-center dir-ltr"
                        append="ریال"
                        disabled={!gheyrMali[item.value]}
                        error={{
                          show: gheyrMali[item.value],
                          color: checkMinMax(
                            gheyrMali[item.changePrice.value],
                            minMax[item.changePrice.min],
                            minMax[item.changePrice.max]
                          )
                            ? "success"
                            : "danger",
                          content: `حداقل ${minMax[
                            item.changePrice.min
                          ].toLocaleString()} و حداکثر ${minMax[
                            item.changePrice.max
                          ].toLocaleString()} ریال`,
                        }}
                      />
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </Wrapper>
    );
  }
}

let mapStateToProps = (state) => ({
  gheyrMali: state.gheyrMali,
  header: state.header,
  footer: state.footer,
  minMax: state.minMax,
  loadign: state.loadign,
});
let mapDispatchToProps = (dispatch) => ({
  setGheyrMali: (data) => {
    dispatch({ type: "SET_GHEYR_MALI", data });
  },
  setMinMax: (data) => {
    dispatch({ type: "SET_MINMAX", data });
  },
  sendData: (data) => {
    dispatch({ type: "SEND_DATA", data });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(NonFinancialClaims);
